<main class="shell" *ngIf="!isUserConfigPage; else userLayout">
  <div class="shell-layout">
    <aside class="panel left-nav">
      <p>{{ 'app.subtitle' | t }}</p>
      <nav class="nav vertical">
        <a routerLink="/admin/products" routerLinkActive="active">{{ 'nav.adminProducts' | t }}</a>
        <a routerLink="/admin/rules" routerLinkActive="active">{{ 'nav.adminRules' | t }}</a>
        <a routerLink="/admin/pricing" routerLinkActive="active">{{ 'nav.adminPricing' | t }}</a>
      </nav>
    </aside>

    <section class="content">
      <header class="panel header">
        <div class="title">
          <h1>{{ 'app.name' | t }}</h1>
        </div>
        <div class="actions">
          <a class="header-link" routerLink="/user/configure">{{ 'nav.userConfigure' | t }}</a>
          <select class="language-select" [ngModel]="language" (ngModelChange)="setLanguage($event)">
            <option value="de">{{ 'lang.de' | t }}</option>
            <option value="en">{{ 'lang.en' | t }}</option>
          </select>
          <button type="button" class="secondary" (click)="toggleTheme()">{{ theme === 'dark' ? ('theme.light' | t) : ('theme.dark' | t) }}</button>
          <button type="button" *ngIf="!authenticated" (click)="login()">{{ 'auth.login' | t }}</button>
          <button type="button" *ngIf="authenticated" (click)="logout()">{{ 'auth.logout' | t }}</button>
          <span class="badge" *ngIf="authenticated">{{ 'auth.tenant' | t:{ tenant: (tenantId || 'n/a') } }}</span>
          <span class="badge warning" *ngIf="!authenticated">{{ 'auth.notAuthenticated' | t }}</span>
        </div>
      </header>

      <section class="panel" *ngIf="error">
        <p class="error">{{ error }}</p>
      </section>

      <router-outlet />
    </section>
  </div>
</main>

<ng-template #userLayout>
  <main class="shell user-shell">
    <section class="content">
      <header class="panel header">
        <div class="title">
          <h1>{{ 'app.name' | t }}</h1>
        </div>
        <div class="actions">
          <a class="header-link" routerLink="/admin/products">{{ 'nav.adminProducts' | t }}</a>
          <select class="language-select" [ngModel]="language" (ngModelChange)="setLanguage($event)">
            <option value="de">{{ 'lang.de' | t }}</option>
            <option value="en">{{ 'lang.en' | t }}</option>
          </select>
          <button type="button" class="secondary" (click)="toggleTheme()">{{ theme === 'dark' ? ('theme.light' | t) : ('theme.dark' | t) }}</button>
        </div>
      </header>

      <section class="panel" *ngIf="error">
        <p class="error">{{ error }}</p>
      </section>

      <router-outlet />
    </section>
  </main>
</ng-template>
